<template>
  <div>
    New {{ rule.config.days }} day {{ rule.config.high_low }}
    <span v-if="rule.config.increased_price_percent">
      {{ rule.config.increased_price_percent }} % change in price</span
    >
    <div
      v-if="
        rule.config.previous_breakout_past_days &&
        rule.config.previous_breakout_high_low &&
        rule.config.previous_breakout_days
      "
    >
      Previous {{ rule.config.previous_breakout_days }} day
      {{ rule.config.previous_breakout_high_low }} breakout within the past
      {{ rule.config.previous_breakout_past_days }} days
    </div>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {}
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
